import { SVGProps } from "react";

export default function AddSquareIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 16, width = 16, stroke = "#E3592E", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M5.33398 8H10.6673"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 10.6667V5.33334"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.00065 14.6667H10.0007C13.334 14.6667 14.6673 13.3333 14.6673 10V6C14.6673 2.66667 13.334 1.33334 10.0007 1.33334H6.00065C2.66732 1.33334 1.33398 2.66667 1.33398 6V10C1.33398 13.3333 2.66732 14.6667 6.00065 14.6667Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
